var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('OrderSearch',{attrs:{"view-type":0}}),_c('OrderList',{attrs:{"is-refuse-accept-complete":_vm.isRefuseAcceptComplete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }